import React from "react";
import dir from "../../../../images/aboutimage/dir.jpeg"
const LeftAboutSection1 = () => {
  return (
    <div id="message">
      <div className="left mx-6 ">
        <div className="bg-black lg:w-full">
          <img
            className="mt-10 w-full lg:w-full"
            src={dir}
            alt=""
          />
        </div>
        <div className="mt-8 lg:w-full">
          <ul className="flex space-x-2">
            <li className="cursor-pointer hover:text-blue-400 font-bold">DIRECTOR</li>
            <li className="cursor-pointer hover:text-blue-400">|</li>
            <li className="cursor-pointer hover:text-blue-400">
              MR. SHIKHAR JAIN
            </li>
          </ul>
          <h1 className="hover: mt-6 text-4xl font-bold">
            Primary focus of the students should be to excel in their studies.
          </h1>
          <hr className="mt-4 border-blue-400" />
          <p className="mt-10 text-xl leading-8">
            We believe that raising a child is a team effort. With a strong team
            supporting them, every child can learn, be well, and thrive. Parents
            and caregivers are the most powerful, capable, and important members
            of a child’s team. However, all too often, parents have to support
            their child’s wellbeing alone. Our public systems have been set up
            so that teachers, pediatricians, and others are working in silos.
            Despite having similar goals, these systems often do not have the
            capacity, scope, or connection to address a child or family’s
            complex needs, particularly when those needs are compounded by
            adversity and other stressful and traumatic experiences.
          </p>
          <br />
          <p className="mt-5 text-xl leading-8">
            Because of systemic racism, communities of color are
            disproportionately affected by these challenges and have the added
            burden of not being able to afford or access adequate services. The
            result is that parents, who have the desire and capability to build
            a better future for their children, must struggle with the
            challenges of systemic poverty while also supporting their children
            alone.
          </p>
        </div>
        <div className="mt-10 w-[100%] border-l-8 border-l-sky-400 bg-slate-200 py-6 text-center text-xl italic lg:w-full">
          <p className=" ">
            "If our school is a pen, the parents are the ink; joining together
            we can write the success story of educational development of our
            children".
          </p>
        </div>
      </div>
    </div>
  );
};

export default LeftAboutSection1;
